export enum ChartType {
  // General Dashboard
  Top5_CMC = 'top5_cmc',
  Total_Volume = 'total_volume',
  Crypto_Prices = 'crypto_prices',
  TVL_per_Blockchain = 'tvl_per_blockchain',
  TVL_per_Protocols = 'tvl_per_protocols',
  Indices_and_Crypto_Returns = 'indices_and_crypto_returns',
  BTC_ETH_Correlation = 'btc_eth_correlation',
  
  // Bitcoin Dashboard
  BTC_Dominance = 'btc_dominance',
  BTC_HASHRATE_BY_COUNTRY = 'btc_hashrate_by_country',
  BTC_MINING_ENERGY_SOURCE = 'btc_mining_energy_source',
  BTC_Per_Share_Treasury_Companies = 'btc_per_share_treasury_companies',
  BTC_VARIATION_VS_MINERS_AND_TREASURIES = 'btc_variation_vs_miners_and_treasuries',
  BTC_VARIATIONS_VS_MINING_COMPANIES = 'btc_variations_vs_mining_companies',
  BTC_VARIATIONS_VS_SP500_GOLD_STOXX50 = 'btc_variations_vs_sp500_gold_stoxx50',
  BTC_VARIATIONS_VS_TREASURIES = 'btc_variations_vs_treasuries',
  CUMULATED_TOTAL_BTC_TREASURIES_COMPANIES = 'cumulated_total_btc_treasuries_companies',
  FED_WIRE_VS_BTC_TRANSACTIONS = 'fed_wire_vs_btc_transactions',
  WHALE_ACCUMULATION = 'whale_accumulation',
  
  // ETFs Dashboard
  ETF_Bitcoin_AUM = 'etf_bitcoin_aum',
  ETF_Bitcoin_AUM_Native = 'etf_bitcoin_aum_native',
  ETF_Bitcoin_Market_Share = 'etf_bitcoin_market_share',
  ETF_Bitcoin_Total_AUM_Native = 'etf_bitcoin_total_aum_native',
  ETF_Bitcoin_Total_AUM_USD = 'etf_bitcoin_total_aum_usd',
  ETF_Ethereum_AUM = 'etf_ethereum_aum',
  ETF_Ethereum_AUM_Native = 'etf_ethereum_aum_native',
  ETF_Ethereum_Market_Share = 'etf_ethereum_market_share',
  ETF_Ethereum_Total_AUM_Native = 'etf_ethereum_total_aum_native',
  ETF_Ethereum_Total_AUM_USD = 'etf_ethereum_total_aum_usd',
  
  // Ethereum Dashboard
  ETH_NASDAQ_Correlation = 'eth_nasdaq_correlation',
  ETH_Network_Fees_Paid_USD = 'eth_network_fees_paid_usd',
  ETH_Network_Rent_Paid = 'eth_network_rent_paid',
  ETH_Network_Rent_Paid_USD = 'eth_network_rent_paid_usd',
  ETH_Staked_By_Entity = 'eth_staked_by_entity',
  ETH_Network_Transaction_Counts = 'eth_network_transaction_counts',
  
  // Stablecoins Dashboard
  RWA_Total_Stablecoins_Euro_TVL = 'rwa_total_stablecoins_euro_tvl',
  RWA_Total_Stablecoins_TVL = 'rwa_total_stablecoins_tvl',
  Stablecoins_vs_M2 = 'stablecoins_vs_m2',
  Stablecoins_Per_Network_RWA = 'stablecoins_per_network_rwa',
  Stablecoins_Yields = 'stablecoins_yields',
  Stablecoins_Artemis_SectorsVolume = 'stablecoins_artemis_sectorsvolume',
  Stablecoin_Artemis_Transactions_ByRegionAjusted = 'stablecoin_artemis_transactions_byregionajusted',
  Stablecoins_Artemis_SupplyUsageUSD = 'stablecoins_artemis_supplyusageusd',
  Stablecoins_Artemis_VolumeVsOtherFinancialSystems = 'stablecoins_artemis_volumevsotherfinancialsystems',
  USD_Stablecoin_Marketcap = 'usd_stablecoin_marketcap',
  
  // RWA Dashboard
  RWA_Ethereum_Stablecoins_TVL = 'rwa_ethereum_stablecoins_tvl',
  RWA_Holders_Networks = 'rwa_holders_networks',
  RWA_Money_Market_Funds_NonTokenized_TVL_FitchRatings = 'rwa_money_market_funds_non_tokenized_tvl_fitch_ratings',
  RWA_Money_Market_Funds_TVL_Issuers = 'rwa_money_market_funds_tvl_issuers',
  RWA_Money_Market_Funds_TVL_Networks = 'rwa_money_market_funds_tvl_networks',
  RWA_Money_Market_Funds_TVL_Products = 'rwa_money_market_funds_tvl_products',
  RWA_Most_Popular_Networks = 'rwa_most_popular_networks',
  RWA_Most_Popular_Networks_No_Stablecoins = 'rwa_most_popular_networks_no_stablecoins',
  RWA_Private_Credit_NonTokenized_TVL_IMF = 'rwa_private_credit_nontokenized_tvl_imf',
  RWA_Private_Credit_TVL_Network = 'rwa_private_credit_tvl_network',
  RWA_Private_Credit_TVL_Protocols = 'rwa_private_credit_tvl_protocols',
  RWA_Stablecoins_Euro_TVL = 'rwa_stablecoins_euro_tvl',
  RWA_Stablecoins_Holders_Networks = 'rwa_stablecoins_holders_networks',
  RWA_Stablecoins_Total_TVL = 'rwa_stablecoins_total_tvl',
  RWA_Total_TVL = 'rwa_total_tvl',
  RWA_Total_TVL_No_Stablecoins = 'rwa_total_tvl_no_stablecoins',
  RWA_Volume_Stablecoins_VS_Visa = 'rwa_volume_stablecoins_vs_visa',
  

   // ETFs Dashboard
  //  ETF_Bitcoin_AUM = 'etf_bitcoin_aum',
  //  ETF_Bitcoin_AUM_Native = 'etf_bitcoin_aum_native',
  //  ETF_Bitcoin_Market_Share = 'etf_bitcoin_market_share',
  //  ETF_Bitcoin_Total_AUM_Native = 'etf_bitcoin_total_aum_native',
  //  ETF_Bitcoin_Total_AUM_USD = 'etf_bitcoin_total_aum_usd',
  //  ETF_Ethereum_AUM = 'etf_ethereum_aum',
  //  ETF_Ethereum_AUM_Native = 'etf_ethereum_aum_native',
  //  ETF_Ethereum_Market_Share = 'etf_ethereum_market_share',
  //  ETF_Ethereum_Total_AUM_Native = 'etf_ethereum_total_aum_native',
  //  ETF_Ethereum_Total_AUM_USD = 'etf_ethereum_total_aum_usd',
  // Legacy / Not in V2 API (kept for backwards compatibility)
  Spot_ETF_ETH_Flows_USD = 'spot_etf_eth_flows_usd',
  ETF_ETH_AUM_Issuer_USD = 'etf_eth_aum_issuer_usd',
  Spot_ETF_BTC_Flows_USD = 'spot_etf_btc_flows_usd',
  ETH_Stacked_Market_Shares = 'eth_stacked_market_shares',
  ETH_Staked_By_Entity_Percent = 'eth_staked_by_entity_percent',
  ETH_Perpetual_Futures_OpenInterest = 'eth_perpetual_futures_openinterest',
  Volumes_CEX_DEX_EURONEXT_NYSE = 'volumes_cex_dex_euronext_nyse',
  ETF_BTC_AUM_Issuer_USD = 'etf_btc_aum_issuer_usd',

  // New V2 API charts (missing from map)
  ETF_Flows = 'etf_flows',
}
